import { j as s } from "./AccesRecoveryIcon-CUPieIxT.js";
const j = () => /* @__PURE__ */ s.jsxs("svg", { viewBox: "0 0 23.625 23.625", children: [
  /* @__PURE__ */ s.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M11.812 0C5.289 0 0 5.289 0 11.812s5.289 11.813 11.812 11.813 11.813-5.29 11.813-11.813S18.335 0 11.812 0m2.459 18.307q-.911.36-1.455.548a3.8 3.8 0 0 1-1.262.189q-1.104 0-1.717-.539c-.613-.539-.611-.814-.611-1.367q0-.323.045-.659a8 8 0 0 1 .147-.759l.761-2.688q.101-.388.171-.731.068-.345.068-.633 0-.514-.212-.717-.213-.202-.813-.201-.294 0-.605.09-.309.093-.529.176l.201-.828q.747-.305 1.43-.521a4.2 4.2 0 0 1 1.29-.218q1.097.001 1.692.53.593.53.594 1.376 0 .176-.041.617a4 4 0 0 1-.152.811l-.757 2.68a8 8 0 0 0-.167.736 4 4 0 0 0-.073.626q0 .534.239.728.238.194.827.194.276 0 .626-.097.348-.096.506-.17zm-.134-10.878a1.8 1.8 0 0 1-1.275.492q-.745 0-1.28-.492a1.57 1.57 0 0 1-.533-1.193q.002-.699.533-1.196a1.8 1.8 0 0 1 1.28-.497q.746 0 1.275.497.53.498.53 1.196 0 .7-.53 1.193"
    }
  ),
  /* @__PURE__ */ s.jsx("g", {}),
  /* @__PURE__ */ s.jsx("g", {}),
  /* @__PURE__ */ s.jsx("g", {}),
  /* @__PURE__ */ s.jsx("g", {}),
  /* @__PURE__ */ s.jsx("g", {}),
  /* @__PURE__ */ s.jsx("g", {}),
  /* @__PURE__ */ s.jsx("g", {}),
  /* @__PURE__ */ s.jsx("g", {}),
  /* @__PURE__ */ s.jsx("g", {}),
  /* @__PURE__ */ s.jsx("g", {}),
  /* @__PURE__ */ s.jsx("g", {}),
  /* @__PURE__ */ s.jsx("g", {}),
  /* @__PURE__ */ s.jsx("g", {}),
  /* @__PURE__ */ s.jsx("g", {}),
  /* @__PURE__ */ s.jsx("g", {})
] });
export {
  j as I
};
